import React from 'react';
import { Collapse } from 'antd';
import CapPopover from '../CapPopover';
import DisabledHoverPopover from './DisabledHoverPopover';
import './_index.scss';
import {
  sortModulesByDisplayOrder,
  SingleRecordItemDiv,
  reducerActions,
  FormattedMessageWrapper,
} from './utils';
import CapIcon from '../CapIcon';
import CapHeading from '../CapHeading';

const { Panel } = Collapse;

const CollapsibleSingleItem = ({
  item,
  itemSelected,
  itemHovered,
  l1_itemHovered,
  disabled,
  handleRedirectionAndModuleSelection,
  dispatchAction,
}) => {
  const {
    name,
    displayLabel,
    isDisabled = false,
    showPremiumIcon = false,
  } = item;
  return (
    <CapHeading
      onMouseOut={() =>
        dispatchAction({
          type: reducerActions.hoveredCollapsibleItem,
          value: '',
        })
      }
      onMouseOver={() =>
        dispatchAction({
          type: reducerActions.hoveredCollapsibleItem,
          value: name,
        })
      }
      onClick={() => !isDisabled && handleRedirectionAndModuleSelection({...item, l1_itemHovered })}
      type="h6"
      className={`l2-collapsible-single ${
        disabled || isDisabled ? 'nav-item-disabled' : ''
      } ${itemSelected ? 'itemSelected' : ''} ${
        !itemSelected && itemHovered && (!disabled && !isDisabled) ? 'itemHovered' : ''
      }`}
    >
      <SingleRecordItemDiv disabled={disabled || isDisabled}>
        <FormattedMessageWrapper id={displayLabel} message={name} />
      </SingleRecordItemDiv>
      {showPremiumIcon ? (
        <CapIcon type="premiumColored" className="premium-icon" />
      ) : (
        ''
      )}
    </CapHeading>
  );
};

const CollapsibleItems = ({
  collapsibleItems,
  handleRedirectionAndModuleSelection,
  dispatchAction,
  currentState,
  pushDataToGTM,
  redirectToLink,
  l1_itemHovered,
}) => {
  const sortedCollapsibleItems = sortModulesByDisplayOrder(collapsibleItems);
  return sortedCollapsibleItems?.filter(item => item?.isVisible).map(item => {
    const { displayLabel, name, disabledConfig = {}, disabled = false, _id } =
      item || {};
    const itemHovered = currentState?.hoveredCollapsibleItem === name;
    const itemSelected = _id ? _id === currentState?.selectedL2Module?._id : name === currentState?.selectedL2Module?.name;
    return disabled ? (
      <CapPopover
        placement="right"
        content={
          <DisabledHoverPopover
            {...disabledConfig}
            title={<FormattedMessageWrapper id={displayLabel} message={name} />}
            redirectToLink={redirectToLink}
            pushDataToGTM={pushDataToGTM}
          />
        }
        overlayClassName={`l1-${
          disabled ? 'disabled' : 'enabled'
        }-popover-container`}
      >
        <CollapsibleSingleItem
          item={item}
          itemSelected={itemSelected}
          itemHovered={itemHovered}
          l1_itemHovered={l1_itemHovered}
          disabled={disabled}
          handleRedirectionAndModuleSelection={
            handleRedirectionAndModuleSelection
          }
          dispatchAction={dispatchAction}
        />
      </CapPopover>
    ) : (
      <CollapsibleSingleItem
        item={item}
        itemSelected={itemSelected}
        itemHovered={itemHovered}
        l1_itemHovered={l1_itemHovered}
        handleRedirectionAndModuleSelection={
          handleRedirectionAndModuleSelection
        }
        dispatchAction={dispatchAction}
      />
    );
  });
};

const CollapsibleItemsWrapper = ({
  name,
  l1_itemHovered,
  displayLabel,
  subModules = [],
  handleRedirectionAndModuleSelection,
  dispatchAction,
  currentState = {},
  pushDataToGTM,
  redirectToLink,
}) => (
  <div onClick={(e) => e.stopPropagation()}>
    <Collapse
      className="l2-item-collapsible-container"
      bordered={false}
      accordion
      expandIconPosition="right"
      expandIcon={({ isActive }) => (
        <CapIcon
          type={isActive ? 'chevron-up' : 'chevron-down'}
          className="icon-up-down"
        />
      )}
      key={`key_${name}`}
    >
      <Panel
        header={<FormattedMessageWrapper id={displayLabel} message={name} />}
        key={name}
      >
        <div>
          <CollapsibleItems
            collapsibleItems={subModules}
            handleRedirectionAndModuleSelection={handleRedirectionAndModuleSelection}
            dispatchAction={dispatchAction}
            currentState={currentState}
            pushDataToGTM={pushDataToGTM}
            redirectToLink={redirectToLink}
            l1_itemHovered={l1_itemHovered}
          />
        </div>
      </Panel>
    </Collapse>
  </div>)

export default CollapsibleItemsWrapper;

